/**
 * Magic Wishlist toast/button copy comes from window.wishlistLanguage.
 * Turkish is not in the app's built-in languages, so merge TR strings here.
 */
(function () {
  var TR_STRINGS = {
    toastAdded: 'Favorilere eklendi',
    toastRemoved: 'Favorilerden kaldırıldı',
    toastView: 'Görüntüle',
    toastClose: 'Kapat',
  };

  var EN_TO_TR = {
    'Added to wishlist': TR_STRINGS.toastAdded,
    'Removed from wishlist': TR_STRINGS.toastRemoved,
    View: TR_STRINGS.toastView,
    Close: TR_STRINGS.toastClose,
  };

  function mergeLanguage(target) {
    return Object.assign({}, target || {}, TR_STRINGS);
  }

  function installLanguageHook() {
    var current = window.wishlistLanguage;

    try {
      Object.defineProperty(window, 'wishlistLanguage', {
        configurable: true,
        enumerable: true,
        get: function () {
          return current;
        },
        set: function (value) {
          current = mergeLanguage(value);
        },
      });
    } catch (_) {
      // Fallback if the property is already defined as non-configurable.
    }

    window.wishlistLanguage = mergeLanguage(current);
  }

  function translateToastDom(root) {
    var scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('.mw-toast-status-text').forEach(function (node) {
      var translated = EN_TO_TR[node.textContent.trim()];
      if (translated) node.textContent = translated;
    });

    scope.querySelectorAll('.mw-toast-view').forEach(function (node) {
      var translated = EN_TO_TR[node.textContent.trim()];
      if (translated) node.textContent = translated;
    });

    scope.querySelectorAll('.mw-toast-close').forEach(function (node) {
      node.setAttribute('aria-label', TR_STRINGS.toastClose);
    });
  }

  function init() {
    installLanguageHook();
    translateToastDom(document);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof Element)) return;
          if (node.classList.contains('mw-toast') || node.querySelector('.mw-toast')) {
            translateToastDom(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
